
import React, {useEffect, useState} from 'react';
import Video from 'twilio-video';

import {Button, Card, Col, FloatButton, message, Popover, Row, Spin, Tooltip} from "antd";
import RemoteParticipantView from "./RemoteParticipantView";
import LocalParticipantView from "./LocalParticipantView";
import {GeoCoords} from "../../../dto/geoCoords";
import {ParticipantStatus} from "../../../enums/ParticipantStatus";
import {VideoStatus} from "../../../enums/VideoStatus";
import {CloseOutlined, LoadingOutlined,} from "@ant-design/icons";

import './style.scss'

import {faCameraRotate, faMicrophone, faMicrophoneSlash, faPhone} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {CameraOutlined} from '@ant-design/icons/lib';

const spinIcon = <LoadingOutlined style={{fontSize: 24}} spin/>;

export default function RemoteRoomComp({
                                           roomName,
                                           token,
                                           handleLogout,
                                           setVideoStatusProgress,
                                           setParticipantConnectingStatus,
                                           username,
                                           remoteUserAccessToken,
                                           geoCoords
                                       }: {
    roomName: string,
    token: string,
    handleLogout: any,
    setVideoStatusProgress(status: VideoStatus): void,
    setParticipantConnectingStatus(participantStatus: ParticipantStatus): void,
    username: string,
    remoteUserAccessToken: string,
    geoCoords: GeoCoords
}) {


    const [room, setRoom] = useState<Video.Room>();
    const [connectionStatus, setConnectionStatus] = useState<VideoStatus>(VideoStatus.OFFLINE);
    const [participants, setParticipants] = useState<Array<Video.RemoteParticipant>>([]);
    const [facingMode, setFacingMode] = useState<string>("");
    const [mute, setMute] = useState<boolean>(false);
    const [notifiedMessage, setNotifiedMessage] = useState<string>("");
    const [isCanShowRecording, setCanShowRecording] = useState<boolean>(false);

    const [open, setOpen] = useState(false);

    const hide = () => {
        setOpen(false);
    };

    const handleOpenChange = (newOpen: boolean) => {
        setOpen(newOpen);
    };
    const tidyUp = (room: Video.Room) => {
        return function (event: any) {
            if (event.persisted) {
                return;
            }
            if (room) {
                room.disconnect();
            }
        };
    }


    useEffect(() => {
       if(notifiedMessage!==''){
           setTimeout(() => {
               setNotifiedMessage('')
           }, 10000);
       }
    }, [notifiedMessage]);
    useEffect(() => {
        const participantConnected = (participant: Video.RemoteParticipant) => {
            let participants: Array<Video.RemoteParticipant> = [];
            participants.push(participant);
            setParticipants(participants)
            setParticipantConnectingStatus(ParticipantStatus.PARTICIPANT_CONNECTED);
        };

        const participantDisconnected = (participant: Video.RemoteParticipant) => {
            setParticipants([]);
            setParticipantConnectingStatus(ParticipantStatus.DISCONNECTED);
        };


        /*navigator.mediaDevices.enumerateDevices().then(devices => {
           console.log("Devices LIST ",devices)
            return  Video.connect(token, {
                name: roomName,
                audio: true,
                maxAudioBitrate: 16000,
                video: {facingMode: 'environment', height: 480, frameRate: 24, width: 640}
            });
        }).then(room => {

            setVideoStatusProgress(VideoStatus.CONNECTING);
            setRoom(room);
            room.on('participantConnected', participantConnected);
            room.on('participantDisconnected', participantDisconnected);
            window.addEventListener("beforeunload", tidyUp(room));
            window.addEventListener("pagehide", tidyUp(room));
            room.participants.forEach(participantConnected);
            setConnectionStatus(VideoStatus.CONNECTED);
            setVideoStatusProgress(VideoStatus.CONNECTED);
        });*/


        Video.connect(token, {
            name: roomName,
            audio: true,
            maxAudioBitrate: 16000,
            video: {facingMode: 'environment', height: 480, frameRate: 24, width: 640}
        }).then((room: Video.Room) => {
            setVideoStatusProgress(VideoStatus.CONNECTING);
            setRoom(room);
            room.on('participantConnected', participantConnected);
            room.on('participantDisconnected', participantDisconnected);
            window.addEventListener("beforeunload", tidyUp(room));
            window.addEventListener("pagehide", tidyUp(room));
            room.participants.forEach(participantConnected);
            setConnectionStatus(VideoStatus.CONNECTED);
            setVideoStatusProgress(VideoStatus.CONNECTED);
        }, (error) => {
            if (error.name === 'NotAllowedError') {
                message.error('Camera and microphone permissions were denied. Please allow permissions in your browser settings.');
            } else {
                message.error('An error occurred while requesting camera and microphone permissions.');
            }
        });


        return () => {
            setRoom((currentRoom) => {
                if (currentRoom && currentRoom.localParticipant.state === 'connected') {
                    currentRoom.localParticipant.tracks.forEach(function (trackPublication) {
                        if (trackPublication.track instanceof Video.LocalAudioTrack) {
                            trackPublication.track.stop();
                        } else if (trackPublication?.track instanceof Video.LocalVideoTrack) {
                            trackPublication.track.stop();
                        }
                        //  trackPublication?.track?.stop();
                    });
                    currentRoom.disconnect();
                    setVideoStatusProgress(VideoStatus.ROOM_DISCONNECTED);
                    setConnectionStatus(VideoStatus.ROOM_DISCONNECTED);
                    return;
                } else {
                    return currentRoom;
                }
            });
        };
    }, [roomName, token]);


    const remoteParticipants = participants.map((participant) => {
        console.log("Remote Participant details ", participants.length)
        if (username !== participant.identity) {
            return (<RemoteParticipantView key={participant.sid} participant={participant}
                                           setVideoStatusProgress={setVideoStatusProgress}/>)
        }
        return <></>

    });

    const onSwitchCamera = (e: any) => {
        if (facingMode == "environment") {
            setFacingMode("user");
        } else {
            setFacingMode("environment");
        }

    }

    const onMuteMicrophone = (e: any) => {

        room?.localParticipant.audioTracks.forEach(publication => {
            if (mute) {
                publication.track.enable();
                setMute(prevState => !prevState)
            } else {
                publication.track.disable();
                setMute(prevState => !prevState);
            }

        })
    }


    return (
        <div>
            <Row gutter={16} className='video-canvas-card-row'>
                {
                    participants.length > 0 ? (
                        <Col xs={24} sm={24} md={24} lg={18} xl={15} xxl={15}>
                            <Row className='canvas-row'>
                                <Col span={24}>
                                    <Card size={'small'} className='video-canvas-card'>
                                        {room ? (
                                            <>
                                                <LocalParticipantView
                                                    facingMode={facingMode}
                                                    key={room.localParticipant.sid}
                                                    participant={room.localParticipant}
                                                    username={username}
                                                    remoteUserAccessToken={remoteUserAccessToken}
                                                    geoCoords={geoCoords}
                                                    notifyMessage={(msg:string)=>setNotifiedMessage(msg)}
                                                    canShowRecording={(value:boolean)=>setCanShowRecording(value)}
                                                />
                                                {notifiedMessage !== '' && (
                                                    <Col span={24} className={'message_div'}>
                                                        <div className={'msg-div-bg'}>
                                                            {notifiedMessage}
                                                        </div>
                                                    </Col>
                                                )}

                                                {isCanShowRecording && (
                                                    <div className="recording-started"> </div>
                                                )}


                                            </>
                                        ) : (
                                            ''
                                        )}


                                    </Card>
                                </Col>
                                <Col span={24} className='button_group_col'>
                                    <div className='call-btn-group'>

                                        <Tooltip title={mute ? "Unmute" : "Mute"}>
                                            <Button type="primary"
                                                    shape="circle"
                                                    className={mute ? 'unmute-btn' : 'mute-btn'}
                                                    icon={mute ? <FontAwesomeIcon icon={faMicrophoneSlash}/> :
                                                        <FontAwesomeIcon icon={faMicrophone}/>}
                                                    onClick={onMuteMicrophone} size={"large"}/>
                                        </Tooltip>

                                        <Tooltip
                                            title={facingMode == "environment" ? "Switch Front Camera" : "Switch Rear Camera"}>
                                            <Button type="primary"
                                                    className={facingMode == "environment" ? 'front-cam-btn' : 'rear-cam-btn'}
                                                    shape="circle"
                                                    icon={<FontAwesomeIcon icon={faCameraRotate} className='cam-icon'/>}
                                                    onClick={onSwitchCamera} size={"large"}/>
                                        </Tooltip>

                                        {
                                            connectionStatus === VideoStatus.CONNECTED &&
                                            <Tooltip title="End Call">
                                                <Button type="primary" className='end-call-btn'
                                                        shape="circle"
                                                        icon={<FontAwesomeIcon icon={faPhone}/>} onClick={handleLogout}
                                                        size={"large"}/>
                                            </Tooltip>
                                        }
                                    </div>
                                </Col>


                            </Row>

                            <div style={{display: "none"}}>{remoteParticipants}</div>
                        </Col>

                    ) : (
                        <Col xs={24} sm={24} md={24} lg={18} xl={15} xxl={15}>
                            <Row style={{display: 'flex', justifyContent: 'center'}}>
                                <Col className='not_join_div margin_top_20' lg={24}>
                                    <div>
                                        <Spin indicator={spinIcon} size={"large"}/>
                                        {/*<h3>Participant will join </h3>*/}
                                        <h3>Please Wait </h3>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    )
                }

            </Row>


            <Popover
                open={open}
                onOpenChange={handleOpenChange}
                content={
                    <>
                        {remoteParticipants}
                    </>
                }
                title={<div className={"popover_close_btn"}>Participant <span> <Button onClick={hide}
                                                                               type="text"><CloseOutlined/></Button></span></div>}
                trigger="click"
                className='participant-video'
            >
                <FloatButton className='float-cam-btn' icon={<CameraOutlined className='float-cam-icon'/>}
                             onClick={() => console.log('click')}/>
            </Popover>
        </div>
    );
}
